/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Purchase_CurrencyInputs */

const en_price_purchase_currency = /** @type {(inputs: Price_Purchase_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase currency`)
};

/**
* | output |
* | --- |
* | "Purchase currency" |
*
* @param {Price_Purchase_CurrencyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_purchase_currency = /** @type {((inputs?: Price_Purchase_CurrencyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Purchase_CurrencyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_purchase_currency(inputs)
});